import { template as template_016815338ca044a2853487651e8928af } from "@ember/template-compiler";
import { not, and } from 'ember-truth-helpers';
import { link as linkHelper } from 'ember-link';
import { on } from '@ember/modifier';
import { concat } from 'ramda';
export default template_016815338ca044a2853487651e8928af(`
{{#if (and @route (not @disabled))}}
  {{#let (linkHelper route=@route model=@model query=@query) as |link|}}
    <a
      class="
        {{if (and link.isActive (not @type)) "active"}}
        {{if @type (concat "btn btn-" @type)}}
      "
      href={{link.url}}
      {{on 'click' link.open}}
      ...attributes
    >
      {{yield}}
    </a>
  {{/let}}
{{else}}
  <a
    class="
      {{if @disabled "disabled"}}
      {{if @type (concat "btn btn-" @type)}}
    "
    href={{@href}}
    ...attributes
  >
    {{yield}}
  </a>
{{/if}}
`, {
    eval () {
        return eval(arguments[0]);
    }
});
